"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransientStorageService = /** @class */ (function () {
    function TransientStorageService() {
        this.items = {};
    }
    TransientStorageService.prototype.getItem = function (key) {
        return Promise.resolve(this.items[key]);
    };
    TransientStorageService.prototype.setItem = function (key, item) {
        this.items[key] = item;
        return Promise.resolve();
    };
    TransientStorageService.prototype.removeItem = function (key) {
        delete this.items[key];
        return Promise.resolve();
    };
    return TransientStorageService;
}());
exports.TransientStorageService = TransientStorageService;
